import IframeWrapper from '../../components/backoffice/iframe-wrapper';
import { useParams } from 'react-router-dom';

export default function PartnerDetails() {
	const { id } = useParams();

	return <IframeWrapper id={'iframe-partner-details'} path={`/shared/nuqlea-studio/partners/${id}`} />;
}
